'use strict';
import {Injectable, Inject} from 'ng-metadata/core';

@Injectable()
export class MediaQueries {


    constructor(@Inject('$mdMedia') private $mdMedia: ng.material.IMedia) {
    }
    public get xs() {
        return this.$mdMedia('xs');
    }
    public get gtxs() {
        return this.$mdMedia('gt-xs');
    }
    public get sm() {
        return this.$mdMedia('sm');
    }
    public get gtsm() {
        return this.$mdMedia('gt-sm');
    }
    public get md() {
        return this.$mdMedia('md');
    }
    public get gtmd() {
        return this.$mdMedia('gt-md');
    }
    public get lg() {
        return this.$mdMedia('lg');
    }
    public get lgPlus() {
        return this.$mdMedia('(min-width: 1600px) and (max-width: 1919px)');
    }
    public get gtlg() {
        return this.$mdMedia('gt-lg');
    }
    public get xl() {
        return this.$mdMedia('xl');
    }

    public createDynamicClass() {

        let screen = '__'; // breakpoing
        let screenGt = '__gt-'; // breakpoint greater than

		if(this.xs) {
            return screen + "xs"
		}
		if(this.sm) {
            return screen + "sm" + ' ' + screenGt + "xs"
		}
		if(this.md) {
            return screen + "md" + ' ' + screenGt + "xs" + ' ' + screenGt + "sm"
		}
        if(this.lgPlus) {
            return screen + "lgPlus" + ' ' + screenGt + "xs" + ' ' + screenGt + "sm" + ' ' + screenGt + "md";
        }
		if(this.lg) {
            return screen + "lg" + ' ' + screenGt + "xs" + ' ' + screenGt + "sm" + ' ' + screenGt + "md"
		}

		if(this.xl) {
            return screen + "xl" + ' ' + screenGt + "xs" + ' ' + screenGt + "sm" + ' ' + screenGt + "md" + ' ' + screenGt + "lg"
		}
		return '';
    }
}




// WEBPACK FOOTER //
// ./src/main/webapp/components/infra/mediaQueries.service.ts